export default "__VITE_ASSET__n0kMR71a__"